import { Component } from 'react'
import { AlertTriangle, RefreshCw, Home } from 'lucide-react'
import { Link } from 'react-router-dom'

// Catches render / lifecycle errors scoped to the current route. Keep mounted
// under Layout so the chrome (sidebar, header, SyncStatus) stays interactive
// even when the inner page crashes. The outer ErrorBoundary in main.jsx still
// catches errors that escape layout-level plumbing.
export default class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('RouteErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="max-w-2xl mx-auto mt-8 bg-white rounded-xl shadow-sm border border-red-100 p-6">
          <div className="flex items-start gap-4">
            <div className="shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
              <AlertTriangle className="h-5 w-5 text-red-600" />
            </div>
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-primary-900 mb-1">
                This page failed to load
              </h2>
              <p className="text-earth-600 text-sm mb-4">
                The rest of the app is still working. Try reloading this page or go back to the dashboard.
              </p>
              {this.state.error && (
                <pre className="text-xs bg-earth-50 rounded-lg p-3 mb-4 overflow-auto max-h-32 text-red-700">
                  {this.state.error.message}
                </pre>
              )}
              <div className="flex gap-3">
                <button
                  onClick={() => window.location.reload()}
                  className="btn bg-primary-600 text-white hover:bg-primary-700 flex items-center gap-2 text-sm"
                >
                  <RefreshCw className="h-4 w-4" />
                  Reload
                </button>
                <Link
                  to="/dashboard"
                  className="btn bg-earth-100 text-earth-700 hover:bg-earth-200 flex items-center gap-2 text-sm"
                >
                  <Home className="h-4 w-4" />
                  Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
